import { formatBrazilianPhoneNumber } from "./authPhoneFormat";

export const PASSWORD_RECOVERY_PENDING_KEY = "orion33_password_recovery_pending";

export const hasPasswordRecoveryUrl = () => {
  if (typeof window === "undefined") return false;
  const urlParams = `${window.location.search || ""}&${window.location.hash || ""}`;
  return /type=recovery/.test(urlParams);
};

export const setPasswordRecoveryPending = (value) => {
  try {
    if (value) {
      localStorage.setItem(PASSWORD_RECOVERY_PENDING_KEY, "1");
    } else {
      localStorage.removeItem(PASSWORD_RECOVERY_PENDING_KEY);
    }
  } catch {}
};

export const isPasswordRecoveryPending = () => {
  try {
    return localStorage.getItem(PASSWORD_RECOVERY_PENDING_KEY) === "1";
  } catch {
    return false;
  }
};

export const getAuthErrorMessage = (error) => {
  const message = error?.message || "";
  if (/invalid login credentials/i.test(message)) {
    return "Email ou senha errado.";
  }

  return message || "Nao foi possivel autenticar.";
};

export const getAuthUrlError = () => {
  if (typeof window === "undefined") return "";

  const params = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(
    (window.location.hash || "").replace(/^#/, "")
  );
  return (
    params.get("error_description") ||
    hashParams.get("error_description") ||
    params.get("error") ||
    hashParams.get("error") ||
    ""
  );
};

const AUTH_CALLBACK_PARAMS = [
  "access_token",
  "refresh_token",
  "provider_token",
  "expires_at",
  "expires_in",
  "token_type",
  "code",
  "state",
  "type",
  "error",
  "error_description",
];

const hasAuthCallbackParams = () => {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(
    (window.location.hash || "").replace(/^#/, "")
  );

  return AUTH_CALLBACK_PARAMS.some(
    (param) => params.has(param) || hashParams.has(param)
  );
};

export const clearAuthCallbackUrl = () => {
  if (typeof window === "undefined" || !hasAuthCallbackParams()) return;

  const cleanUrl = new URL(window.location.href);
  AUTH_CALLBACK_PARAMS.forEach((param) => cleanUrl.searchParams.delete(param));
  cleanUrl.hash = "";

  window.history.replaceState(
    window.history.state,
    document.title,
    `${cleanUrl.pathname}${cleanUrl.search}`
  );
};

const splitFullName = (fullName = "") => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return { firstName: "", lastName: "" };

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(" "),
  };
};

export const getUserProfileFields = (user) => {
  const metadata = user?.user_metadata || {};
  const fallbackName = splitFullName(metadata.full_name || metadata.name || "");
  const phone = metadata.phone || formatBrazilianPhoneNumber(metadata.phone_digits || "");

  return {
    firstName:
      metadata.first_name ||
      metadata.given_name ||
      fallbackName.firstName ||
      "",
    lastName:
      metadata.last_name ||
      metadata.family_name ||
      fallbackName.lastName ||
      "",
    phone,
  };
};

export const getAuthProviders = (user) => user?.app_metadata?.providers || [];
